import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2000,
  timerProgressBar: true,
  customClass: {
    popup: 'ct-toast',
    title: 'ct-toast-title',
  },
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

export const notifySuccess = (title: string, text?: string) => {
  Toast.fire({ icon: 'success', title, text });
};

export const notifyError = (title: string, text?: string) => {
  Toast.fire({ icon: 'error', title, text, timer: 4000 });
};

export const notifyInfo = (title: string, text?: string) => {
  Toast.fire({ icon: 'info', title, text });
};

export const notifyWarning = (title: string, text?: string) => {
  Toast.fire({ icon: 'warning', title, text });
};